import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { AfterViewChecked, ChangeDetectorRef, Component, Directive, ElementRef, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, exhaustMap, filter, interval, retry, Subject, Subscription, switchMap, take, takeUntil, takeWhile, throwError, timeout } from 'rxjs';
import { BasicMachineFunctionsService, t_Version } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';
import { DidConfigService } from 'src/app/services/apiHandler/did-config/did-config.service';
import { DidDataRetrievalService, t_DataIdentifier } from 'src/app/services/apiHandler/did-data-retrieval/did-data-retrieval.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { e_endOfLine, e_errorCodes, initComissionEOLDataset, initComissionLogDataset, initComissionOptionsDataset, initComissionParaDataset, ListItem, SubItem, t_ComissionDataset } from './data/comissioning-dataNames';
import { RoleService } from 'src/app/services/helper/role-handling-helper';
import { MatStepper } from '@angular/material/stepper';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';


// Directive for AutoScroll
@Directive({
  selector: '[autoScroll]'
})
export class AutoScrollDirective implements AfterViewChecked {

  constructor(private el: ElementRef<HTMLDivElement>) {}

  ngAfterViewChecked(): void {
    console.log('checked');
    
    const container = this.el.nativeElement;
    container.scrollTop = container.scrollHeight;
  }
}



@Component({
  selector: 'app-comissioning',
  templateUrl: './comissioning.component.html',
  styleUrls: ['./comissioning.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class ComissioningComponent implements OnInit, OnDestroy {

  private comissionDataset!: t_ComissionDataset;
  public machinenumber: string = "";
  public versions: t_Version[] = [];
  public version_timestamp: string = "";
  public loading: boolean = false;
  public lastStepCompleted: boolean = false;
  public state!: string;
  public allLoaded: boolean = false;

  private queryFrequency: number = 1000;
  private pollingFrequency: number;
  private destroyed: boolean = false;
  private destroy$: Subject<void> = new Subject<void>();

  // LOG DELIVERY STATE
  public strHashPara: string = "";
  public strHashOption: string = "";
  public paraHashLoading: boolean = false;
  public optionHashLoading: boolean = false;
  public comment: string = "";
  public user = "";
  public loadingLog: boolean = false;
  public logError: boolean = false;
  private hashSubscription: any;
  public logDone: boolean = false;

  // PARAMETER + OPTIONS
  public setStates = {
    para: {
      dataset: initComissionParaDataset,
      loading: false,
      start: false,
      set: false,
      startError: false,
      interval: undefined as Subscription | undefined,
      progressStart: false,
      progressMode: 'buffer' as ProgressBarMode,
      progressValue: 0,
      progressError: ''
    }, 
    options: {
      dataset: initComissionOptionsDataset,
      loading: false,
      start: false,
      set: false,
      startError: false,
      interval: undefined as Subscription | undefined,
      progressStart: false,
      progressMode: 'buffer' as ProgressBarMode,
      progressValue: 0,
      progressError: ''
    }
  }
  private oldValue: number = 0;

  private readonly errorMessages: Record<e_errorCodes, string> = {
    [e_errorCodes.File_Invalid]: 'COMISSION.ERROR.FILE_INVALID',
    [e_errorCodes.Machine]: 'COMISSION.ERROR.MACHINE',
    [e_errorCodes.Timeout]: 'COMISSION.ERROR.TIMEOUT',
    [e_errorCodes.File_Open]: 'COMISSION.ERROR.FILE_OPEN',
    [e_errorCodes.Validation]: 'COMISSION.ERROR.VALIDATION',
  }

  // EOL
  public eolTreeLoading: boolean = false;
  public eolState!: string;
  public eolDone: boolean = false;
  public modi: string = "test";
  public eolStarted: boolean = false;
  public items: ListItem[] = [];
  public selectedItem: SubItem | null = null;
  public selectedParent: ListItem | null = null;
  public preFulfilled: boolean = false;
  public execFulfilled: boolean = false;
  public testRunning: boolean = false;
  public checkRunningTest: boolean = false;
  public checkSettingTest: boolean = false;
  public confirmBtnLoading: boolean = false;
  public rejectBtnLoading: boolean = false;
  public loadEval: boolean = false;
  public failedTest: boolean = false;
  public showConfirmBtn: boolean = false;
  private subscription: any;
  private interval: any;
  public imgOpen: boolean = false;
  public progress = 0;
  public eolCompleted: boolean = false;
  public successfulTestRetry: boolean = false;
  public errorWhileStartingTest: boolean = false;
  public selectedImgUrl = '';
  snackbar = inject(MatSnackBar);
  public clickPermission: boolean = true;
  public eolTreeError: boolean = false;
  public eolTestError: boolean = false;

  //REPORT
  public reportLoading: boolean = false;
  public reportSuccess: boolean = false;
  public reportError: boolean = false;
  public reportLink: string = '';
  private reportSubscription: any;



  constructor(public dialog: MatDialog, public global: GlobalService, private commService: BasicMachineFunctionsService, private dataRetrieval: DidDataRetrievalService, private didConfigService: DidConfigService, private translate: TranslateService, public roleService: RoleService, private ref: ChangeDetectorRef) {
    this.global.machineNumber.subscribe({
      next: newValue => {this.machinenumber = newValue.number;}
    });
    this.global.swVersion.subscribe({
      next: newValue => {
        this.versions = newValue.versions;
      }
    });
    this.global.user.subscribe({
      next: newValue => {
        this.user = newValue.name;
      }
    });
    if (this.queryFrequency <= 65) {
      this.pollingFrequency = 50;
    } else {
      this.pollingFrequency = parseFloat((this.queryFrequency * 0.75).toFixed(0));
    }
  }

  ngOnInit(): void {
    this.allLoaded = false;
    this.fetchEolTree().then(() => {
      this.allLoaded = true; 
      this.eolTreeError = false; 
    });
  }

  ngOnDestroy(): void {
    if (this.selectedImgUrl) {
      URL.revokeObjectURL(this.selectedImgUrl);
    }
    this.dialog?.closeAll();
    this.destroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    this.stopDataRetrieval();
    this.endEOL();
  }


  private setupProcess(initDataset: t_ComissionDataset): Promise<void> {
    return new Promise((resolve) => {
      this.comissionDataset = JSON.parse(JSON.stringify(initDataset));
      this.getDataIdentifiersToDataNamesFromConfig();
        this.postDataIdentifierToQueryToBackend().then(() => {
          if(this.destroyed){
            this.ngOnDestroy();
          } else {
            resolve();
          }
        });
    });
  }

  private getDataIdentifiersToDataNamesFromConfig() {
    this.comissionDataset!.dataPoints.forEach((dataPoint) => {
      dataPoint.dataName.identifier = this.didConfigService.getDataIdentifierOfDataName(dataPoint.dataName.name);
      dataPoint.dataName.didInformation = this.didConfigService.getDidInformation(dataPoint.dataName.identifier);
    });
    this.comissionDataset!.dataPoints = this.comissionDataset!.dataPoints
      .map((dataPoint) => dataPoint)
      .filter((dataPoint) => dataPoint.dataName.identifier?.ecu_id !== undefined);
    if(this.destroyed) {
      this.ngOnDestroy();
    }
  }

  private postDataIdentifierToQueryToBackend(): Promise<void> {
    return new Promise((resolve) => {
      let dataIdentifierList: t_DataIdentifier[] = this.comissionDataset!.dataPoints
        .filter((dataPoint) => dataPoint.dataName.didInformation?.readWrite === 'ReadOnly')
        .map((dataPoint) => dataPoint.dataName.identifier)
        .filter((identifier) => identifier?.ecu_id !== undefined) as t_DataIdentifier[];
      this.didConfigService.postNewDidQueryList(dataIdentifierList).subscribe({
        complete: () => {
          resolve();
        },
      });
    });
  }

  private stopDataRetrieval() {
    this.setStates.para.interval?.unsubscribe();
    this.setStates.options.interval?.unsubscribe();
    this.dataRetrieval.stopSendQueryAliveState();
    this.dataRetrieval.stopDataQuery();
    this.dataRetrieval.cleanDataPoints();
  }


  /** DELIVERY STATE */

  public initLogPage() {
    this.reportSubscription?.unsubscribe();
    this.paraHashLoading = true;
    this.optionHashLoading = true;
    this.logDone = true;
    this.setupProcess(initComissionLogDataset).then(() => {
      this.dataRetrieval.initService();
      this.dataRetrieval.startDataQuery();
      // get parameter hash
      let paraIdentifier = this.comissionDataset!.dataPoints[0].dataName.identifier!;
      this.getHash('para', [paraIdentifier]).then(() => {
        this.hashSubscription.unsubscribe();
        if(this.strHashPara === '') {
          this.strHashPara = this.translate.instant('COMISSION.HASH_ERROR');
        }
        this.paraHashLoading = false;
        // get option hash
        let optionsIdentifier = this.comissionDataset!.dataPoints[1].dataName.identifier!;
        this.getHash('option',[optionsIdentifier]).then(() => {
          this.hashSubscription.unsubscribe();
          if(this.strHashOption === '') {
            this.strHashOption = this.translate.instant('COMISSION.HASH_ERROR');
          }
          this.optionHashLoading = false;
          this.logDone= false;
          this.dataRetrieval.stopSendQueryAliveState();
          this.dataRetrieval.stopDataQuery();
          this.dataRetrieval.cleanDataPoints();
        });
      });
    });
  }

  public logAll() {
    this.loadingLog = true;
    let versionJson = Object.fromEntries(this.versions.map(item => [item.name, item.version]));
    let logData = {
      softwareVersions: versionJson,
      parameterHash: this.strHashPara,
      optionsHash: this.strHashOption,
      comment: this.comment
    }
    this.dataRetrieval.initService();
    this.dataRetrieval.startDataQuery();
    this.removeEOLFramework().then(()=> {
      this.commService.logDeliveryState(logData).subscribe({
        complete: () => {
          this.setEolFlagDone().then((state) => {
            this.loadingLog = false;
            this.dataRetrieval.stopSendQueryAliveState();
            this.dataRetrieval.stopDataQuery();
            this.dataRetrieval.cleanDataPoints();
            if(state) {
              this.lastStepCompleted = true;
              this.state = 'done';
              this.logDone = true;
              this.global.comission.next({enabled: false});
              this.dialog.open(ComissionDialog, {
                width: '50%',
                data: 'done'
              });
            } else {
              this.logError = true;
            } 
          });
        },
        error: (error) => {
          console.error(error);
          this.loadingLog = false;
          this.logError = true;
          this.dataRetrieval.stopSendQueryAliveState();
          this.dataRetrieval.stopDataQuery();
          this.dataRetrieval.cleanDataPoints();
        }
      });
    });
  }

  private removeEOLFramework(): Promise<void> {
    return new Promise((resolve) => {
      let identifier = this.comissionDataset!.dataPoints[2].dataName.identifier!;
      this.didConfigService.writeDataByID(identifier!.ecu_id,identifier!.data_id, 1).pipe(
        retry(1)
      ).subscribe({
        complete: () => {
          resolve();
        },
        error: (error) => {
          console.error(error);
          resolve();          
        }
      });
    });
  }

  /** get Hash from Backend and translate into string */
  private getHash(type: string, identifier: t_DataIdentifier[]): Promise<void> {
    return new Promise((resolve) => {
      this.hashSubscription = interval(1000).pipe(
        switchMap(() => this.dataRetrieval.getRawDidsDetails(identifier)),
        takeWhile((resp) => {
          let data = resp.body;
          let timestamp = data![0].data![data![0].data!.length-1].timestamp;
          return new Date(timestamp).getTime() !== -1;
        }, true)
      ).subscribe({
        next: (resp) => {
          if(resp.body != null) {
            let data = resp.body;
            if(data[0].data!.length > 0) {
              let hash = data[0].data![data[0].data!.length-1].value;
              // hash to string
              let strHash = Object.values(hash)
                .map(c => String.fromCharCode(c))
                .join('')
                .replace(/\0.*$/, '');

              if(type === 'para') {
                this.strHashPara = strHash;
              } else if(type === 'option') {
                this.strHashOption = strHash;
              }
            }
            resolve();  
          } 
        },
        error: (error) => {
          console.error(error);
          resolve();
        }
      });
    });
  }

  private setEolFlagDone(): Promise<boolean> {
    return new Promise((resolve) => {
      this.dataRetrieval.setEOLTestDoneFlag(this.machinenumber).subscribe({
        complete:() => {
          resolve(true);
        },
        error: (err) => {
          console.error(err);
          resolve(false);
        }
      })
    });
  }


  /** SET PARAMETERS AND OPTIONS */

  public setParaOptions(type: 'para' | 'options') {
    console.log(type);
    
    this.setStates[type]['loading'] = true;
    this.setupProcess(this.setStates[type]['dataset']).then(() => {
      this.startSetting(type).then(() => {
        if(this.setStates[type]['start']) {
          let identifier = this.comissionDataset!.dataPoints[1].dataName.identifier;
          this.didConfigService.postNewDidQueryList([identifier]).subscribe({
            complete: () => {
              this.dataRetrieval.initService();
              this.dataRetrieval.startDataQuery();
              this.setStates[type]['progressStart'] = true;
              this.setStates[type]['interval'] = interval(this.pollingFrequency).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.checkForStatus(type);
              });
            }
          });
        }
      });
    });
  }

  private startSetting(type: 'para' | 'options'): Promise<void> {
    return new Promise((resolve) => {
      let identifier = this.comissionDataset!.dataPoints[0].dataName.identifier;
      this.didConfigService.writeDataByID(identifier!.ecu_id, identifier!.data_id, 1).subscribe({
        complete: () => {
          this.setStates[type]['start'] = true;
          this.setStates[type]['loading'] = false;
          resolve();
        },
        error: (error) => {
          console.error(error);
          this.setStates[type]['startError'] = true;
          this.setStates[type]['loading'] = false;
          resolve();
        }
      });
    });
  }

  private checkForStatus(type: 'para' | 'options') {
    console.log('check', type);
    
    let identifier = this.comissionDataset!.dataPoints[1].dataName.identifier!;
    this.dataRetrieval.getComissionStatusDidsDetails([identifier]).subscribe({
      next: (resp) => {
        if(resp.body) {
          let data = resp.body;
          console.log(data);
          
          if(data[0].data!.length > 0) {
            let progress = data[0].data![data[0].data!.length-1].value[0];
            let error = data[0].data![data[0].data!.length-1].value[1];
            console.log('progress ', progress, ' ; error ', error);
            
            // progress
            if((0 <= progress) && (progress <= 100)) {
              this.setStates[type]['progressMode'] = 'determinate';
              this.setStates[type]['progressValue'] = progress;
            }
            // start or end value
            if(progress === -1) {
              // setting successful
              if(this.oldValue > 0 && error === 0) {
                this.setStates[type]['set'] = true;
                this.setStates[type]['progressStart'] = false;
                this.stopDataRetrieval();
                this.oldValue = 0;
              }
              // error
              if(error > 0) {
                this.setStates[type]['progressStart'] = false;
                this.stopDataRetrieval();
                let key = this.errorMessages[error as e_errorCodes];
                if(key) {
                  this.setStates[type]['progressError'] = this.translate.instant(key);
                }
              }
            }
            this.oldValue = progress;
          } 
        } 
      },
      error: (error) => {
        console.error(error);
        this.setStates[type]['startError'] = true;
        this.setStates[type]['loading'] = false;
        this.stopDataRetrieval();
      }
    });
  }

  public skipEol(stepper: MatStepper) {
    if(this.eolState === 'disabled') {
      //this.eolCompleted = true;
      stepper.selectedIndex = 3;
      this.initLogPage();
    }
  }


  /* End Of Line */ 

  private fetchEolTree(): Promise<void> {
    this.eolTreeError = false;
    return new Promise((resolve) => {
      this.setupProcess(initComissionEOLDataset).then(() => {
        // hier code für eolTree holen
        let identifier = this.comissionDataset!.dataPoints[6].dataName.identifier!;
        this.dataRetrieval.initService();
        this.dataRetrieval.startDataQuery();
        this.subscription = interval(1000).pipe(
          switchMap(() => this.dataRetrieval.getRawDidsDetails([identifier])),
          filter((resp) => {
            let data = resp.body;
            let timestamp = data![0].data![data![0].data!.length-1].timestamp;
            //return Number(timestamp) !== -1;
            return new Date(timestamp).getTime() !== -1;
          }),
          take(1)
          /*takeWhile((resp) => {
          let data = resp.body;
          let timestamp = data![0].data![data![0].data!.length-1].timestamp;
          //return Number(timestamp) !== -1;
          return new Date(timestamp).getTime() === -1;
          },true)*/
        ).subscribe({
          next: (resp) => {
            if(resp.body != null) {
              let tree = resp.body;
              if(tree.length <= 0) {
                this.eolState = 'disabled';
              } else {
                if(tree[0].data!.length > 0) {
                  let treeString = tree[0].data![tree[0].data!.length-1].value;
                  // hash to string
                  let strJson = Object.values(treeString)
                    .map(c => String.fromCharCode(c))
                    .join('')
                    .replace(/\0.*$/, '');
                  if(strJson === "Couldnt Connect") {
                    this.eolState = 'disabled';
                  } else {
                    let jsonObj = JSON.parse(strJson);
                    this.items = jsonObj;
                  }
                }
              }
              this.stopDataRetrieval();
              this.subscription.unsubscribe();
              resolve();
            }
          },
          error: (error) => {
            console.error(error);
            this.stopDataRetrieval();
            this.eolTreeError = true;
            resolve();
          }
        });
      });
    });
  }
  
  // EOL START CODE
  public startEOL() {
    this.eolTreeLoading = true;
    this.fetchEolTree().then(() => {
      this.eolTreeLoading = false;
      if(!this.eolTreeError) {
        this.updateProgress();
        this.eolStarted = true; 
      } else {
        this.eolStarted = false;
      }
    });
  }
  
  public endEOL() {
    this.eolStarted = false;
    this.selectedItem = null;
    this.selectedParent = null;
    this.subscription?.unsubscribe();
    this.interval?.unsubscribe();
    this.resetAllVars();
    this.stopTest();
    this.stopDataRetrieval();
  }
  
  public saveEOL(): Promise<void> {
    return new Promise((resolve) => {
      this.cleanTree().then(() => {
        let testResults = {
          "maschinennummer": this.machinenumber,
          "stOverride": !this.eolDone,
          "testResults": this.items
        }
        this.commService.saveEolTestResults(testResults).subscribe({
          complete: () => {
            resolve();
          },
          error: (err) => {
            console.error(err);
            this.snackbar.open(this.translate.instant('COMISSION.EOL.ERROR_SAVE'), this.translate.instant('ERROR.ACTION'), {verticalPosition: 'top', panelClass: 'error-snackbar', duration: 5000});
          }
        });
      });
    });
  }

  private cleanTree(): Promise<void> {
    return new Promise((resolve) => {
      this.items.forEach((item) => {
        item.subItems?.forEach((subitem) => {
          delete subitem.imageURL;
          delete subitem.type;
          delete subitem.lastText;
        });
      });
      resolve();
    });
  }
  
  private resetAllVars() {
    this.preFulfilled= false;
    this.execFulfilled = false;
    this.testRunning  = false;
    this.checkRunningTest  = false;
    this.checkSettingTest = false;
    this.confirmBtnLoading = false;
    this.rejectBtnLoading = false;
    this.loadEval = false;
    this.showConfirmBtn = false;
    this.failedTest = false;
    this.successfulTestRetry = false;
    this.errorWhileStartingTest = false;
    this.clickPermission = true;
    this.eolTreeError = false;
    this.eolTestError = false;
  }
  
  public onItemClick(item: SubItem, parent?: ListItem) {
    this.stopDataRetrieval();
    this.resetImgUrl();
    this.resetAllVars();
    this.resetSelectedItemExecText(item);
    this.updateProgress();
    this.selectedItem = item;
    this.selectedParent = parent || (item as ListItem);
  
    this.subscription?.unsubscribe();
    this.interval?.unsubscribe();
    if(this.selectedItem.state === 'success') {
      this.execFulfilled = true;
      this.selectedItem.eval = ["Test erfüllt"];
      this.successfulTestRetry = true;
      return
    }
    if(this.selectedItem.type === 'foto') {
      this.setImageUrl(this.selectedItem.imageURL!);
    }
    this.clickPermission = false;
    this.checkSettingTest = true;
    let identifier = this.comissionDataset!.dataPoints[0].dataName.identifier;
    this.didConfigService.writeDataByID(identifier!.ecu_id, identifier!.data_id, item.id).pipe(
      retry(3)
    ).subscribe({
      complete: () => {
        this.checkSettingTest = false;
        this.checkRunningTest = true;
        this.dataRetrieval.initService();
        this.dataRetrieval.startDataQuery(500);
        this.checkTestRunning();
      },
      error: (error) => {
        this.checkSettingTest = false;
        this.errorWhileStartingTest = true;
        this.clickPermission = true;
        this.stopDataRetrieval();
        this.dialog.open(ComissionDialog, {
          width: '50%',
          data: 'error'
        });
        console.error('click', error);
      }
    });
  }

  public restartSuccessfulTest() {
    this.selectedItem!.state = 'notStarted';
    this.successfulTestRetry = false;
    this.updateParentDoneState(this.selectedParent!);
    this.onItemClick(this.selectedItem!, this.selectedParent!);
  }
  
  private checkTestRunning() {
    let identifier = this.comissionDataset!.dataPoints[4].dataName.identifier!;
    this.subscription = interval(1000).pipe(
      switchMap(() => this.dataRetrieval.getDidsDetails([identifier])),
      takeWhile((resp) => {
        let res = JSON.parse(JSON.stringify(resp.body));
        return res !== this.selectedItem?.id;
      }, true),
      timeout(10000)
    ).subscribe({
      next: (resp) => {
        let res = JSON.parse(JSON.stringify(resp.body));
        let id = res[0].data![res[0].data!.length-1].value[0];
        if (id === this.selectedItem?.id) {
          this.clickPermission = true;
          this.startCycle();
        }
      },
      error: (error) => {
        console.error(error);
        this.clickPermission = true;
        this.errorWhileStartingTest = true;
        this.stopDataRetrieval();
        this.dialog.open(ComissionDialog, {
          width: '50%',
          data: 'error'
        });
      }
    });
  }

  private startCycle() {
    this.subscription?.unsubscribe();
    this.interval = interval(1000).pipe(takeUntil(this.destroy$)).subscribe(() => {this.listenForData()});
  }

  private async listenForData() {
    let out_str = "";
    let out_cmd = 0;
    await this.getOutcmdData().then((data) => {
      out_cmd = data[0];
      out_str = data[1];
    });
    
    //PRECONDITION
    if(out_cmd === e_endOfLine.Precondition && out_str != '') {
      this.selectedItem!.lastText = 'pre';
      this.selectedItem!.pre ??= [];
      if(this.selectedItem!.pre[this.selectedItem!.pre.length - 1] !== out_str) {
        this.selectedItem!.pre!.push(out_str);
      }
      //this.selectedItem!.pre = [out_str];
      this.testRunning = true;
      this.checkRunningTest = false;
    }
    //JUSTCONFIRMATION
    if(out_cmd === e_endOfLine.Confirmation_Btn) {
      //this.selectedItem!.pre = [out_str];
      this.selectedItem!.lastText = 'pre';
      this.selectedItem!.pre ??= [];
      if(this.selectedItem!.pre[this.selectedItem!.pre.length - 1] !== out_str) {
        this.selectedItem!.pre!.push(out_str);
      }
      this.selectedItem!.exec = [''];
      this.testRunning = true;
      this.checkRunningTest = false;
      this.preFulfilled = true;
      this.showConfirmBtn = true;
    }
    //EXECUTION
    if(out_cmd === e_endOfLine.Execution) {
      this.selectedItem!.lastText = 'exec';
      this.checkRunningTest = false;
      this.selectedItem!.exec ??= [];
      if(this.selectedItem!.exec[this.selectedItem!.exec.length - 1] !== out_str) {
        this.selectedItem!.exec!.push(out_str);
      }
      this.preFulfilled = true;
    }
    // EVALUATION 
    if(out_cmd === e_endOfLine.Evaluation) {
      this.selectedItem!.lastText = 'eval';
      this.checkRunningTest = false;
      this.selectedItem!.eval ??= [];
      if(this.selectedItem!.eval[this.selectedItem!.eval.length - 1] !== out_str) {
        this.selectedItem!.eval!.push(out_str);
      }
      //this.selectedItem!.eval = [out_str];
      this.preFulfilled = true;
    }
    //EVALUATION - SUCCESS
    if(out_cmd === e_endOfLine.Success) {
      this.checkRunningTest = false;
      this.execFulfilled = true;
      this.confirmBtnLoading = false;
      this.rejectBtnLoading = false;
      this.selectedItem!.state = 'success';
      this.selectedItem!.lastText = 'eval';
      this.selectedItem!.eval = [out_str];
      this.markAsDone(this.selectedItem!, this.selectedParent!);
      this.stopTest();
    }
    //EVALUATION - FAILURE
    if(out_cmd === e_endOfLine.Failure) {
      this.checkRunningTest = false;
      this.execFulfilled = true;
      this.confirmBtnLoading = false;
      this.rejectBtnLoading = false;
      this.selectedItem!.lastText = 'eval';
      this.selectedItem!.eval = [out_str];
      this.selectedItem!.state = 'failed';
      this.stopTest();
      this.failedTest = true;
    }
    //EVALUATION - PENDING
    if(out_cmd === e_endOfLine.Pending) {
      this.checkRunningTest = false;
      this.execFulfilled = true;
      this.confirmBtnLoading = false;
      this.rejectBtnLoading = false;
      this.selectedItem!.lastText = 'eval';
      this.selectedItem!.eval = [out_str];
      this.loadEval = true;
    }
  }

  private async getOutcmdData(): Promise<[number,string]> {
    return new Promise((resolve) => {
      let out_str: string;
      let out_cmd: number;
      let outIdentifier = this.comissionDataset!.dataPoints[7].dataName.identifier!;

      this.dataRetrieval.getRawDidsDetails([outIdentifier]).subscribe({
        next: (resp) => {
          if(resp.body != null) {
            const data = resp.body;
            const rawData = data[0].data![data[0].data!.length-1].value;
            const bytes = new Uint8Array(Object.values(rawData));

            // first 4 bytes in big-endian
            out_cmd = ((bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | (bytes[3])) >>> 0;

            // string in rest of bytes
            let stringBytes = bytes.subarray(4);            
            let strRaw = Array.from(stringBytes)
              .map(c => String.fromCharCode(c))
              .join('')
              .replace(/\0.*$/, '');
            out_str = JSON.parse('"' + strRaw.replace(/"/g, '\\"') + '"');

            resolve([out_cmd, out_str]);
          } else {
            resolve([out_cmd, out_str]);
          }
        },
        error: (error) => {
          console.error(error);
          /*this.stopDataRetrieval();
          this.eolTestError = true;
          this.stopTest();*/
          //ErrorMessage??
          resolve([out_cmd, out_str]);
        }
      });
    });
  }

  private stopTest() {
    this.subscription?.unsubscribe();
    this.interval?.unsubscribe();
    if(this.comissionDataset?.dataPoints[5]){
      let identifier = this.comissionDataset?.dataPoints[5].dataName.identifier!;
      this.didConfigService.writeDataByID(identifier!.ecu_id, identifier!.data_id, 1).pipe(
        retry(3),
        catchError((error) => {
          console.log(error);
          this.stopDataRetrieval();
          return throwError(() => error);
        })
      ).subscribe({
        complete: () => {
          this.subscription?.unsubscribe();
          this.interval?.unsubscribe();
          this.stopDataRetrieval();
        },
        error: (error) => {
          console.error(error);
        }
      });
    }
  }

  public confirmTest() {
    this.confirmBtnLoading = true;
    let identifier = this.comissionDataset!.dataPoints[1].dataName.identifier!;
    this.didConfigService.writeDataByID(identifier!.ecu_id, identifier.data_id!, e_endOfLine.Confirm_Test).pipe(
      retry(3),
      catchError((error) => {
        console.log(error);
        this.stopDataRetrieval();
        this.eolTestError = true;
        this.stopTest();
        this.resetAllVars();
        this.dialog.open(ComissionDialog, {
          width: '50%',
          data: 'errorTest'
        });
        return throwError(() => error);
      })
    ).subscribe({
      complete: () => {
        this.preFulfilled = true;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  public rejectTest() {
    this.rejectBtnLoading = true;
    let identifier = this.comissionDataset!.dataPoints[1].dataName.identifier!;
    this.didConfigService.writeDataByID(identifier!.ecu_id, identifier.data_id!, e_endOfLine.Reject_Test).pipe(
      retry(3),
      catchError((error) => {
        console.log(error);
        this.stopDataRetrieval();
        this.eolTestError = true;
        this.stopTest();
        this.resetAllVars();
        this.dialog.open(ComissionDialog, {
          width: '50%',
          data: 'errorTest'
        });
        return throwError(() => error);
      })
    ).subscribe({
      complete: () => {
        this.preFulfilled = true;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  public restartTest() {
    this.onItemClick(this.selectedItem!, this.selectedParent!);
  }

  public markAsDone(item: ListItem | SubItem, parent?: ListItem) {
    if('state' in item) {
      item.state = 'success';
    }
    if (parent) {
      this.updateParentDoneState(parent);
    } else if ('subItems' in item && item.subItems) {
      // If toggling a parent, cascade done state to all subitems
      item.subItems.forEach(sub => {sub.done = item.done; sub.state = 'success';});
    }
    this.updateProgress();
  }
  
  public updateParentDoneState(parent: ListItem) {
    if (!parent.subItems || parent.subItems.length === 0) return;
 
    const allDone = parent.subItems.every(sub => sub.state === 'success');
    parent.done = allDone;
  }
 
  public isSelected(item: ListItem | SubItem): boolean {
    return this.selectedItem === item;
  }
  
  public getSelectedSubIndex(): number {
    if(!this.selectedItem || !this.selectedParent?.subItems) {
      return -1;
    }
    return this.selectedParent.subItems.indexOf(this.selectedItem as SubItem);
  }
  
  public hasPrevious(): boolean {
    if(!this.selectedParent || !this.selectedItem) {
      return false;
    }
    let index = this.getSelectedSubIndex();
    let parentIndex = this.items.indexOf(this.selectedParent);
    if(index > 0) {
      return true;
    }
    let bool = parentIndex > 0 && this.items[parentIndex - 1].subItems && this.items[parentIndex - 1].subItems!.length > 0;
    return bool!;
  }
  
  public hasNext(): boolean {
    if(!this.selectedParent || !this.selectedItem) {
      return false;
    }
    let index = this.getSelectedSubIndex();
    let parentIndex = this.items.indexOf(this.selectedParent);
    if(index < this.selectedParent.subItems!.length - 1) {
      return true;
    }
    let bool = parentIndex < this.items.length - 1 && this.items[parentIndex + 1].subItems && this.items[parentIndex + 1].subItems!.length > 0;
    return bool!;
  }
  
  public goPrevious() {
    if(!this.selectedParent || !this.selectedItem) {
      return;
    }
    this.resetAllVars();
    this.preFulfilled = false;
    this.execFulfilled = false;
    let index = this.getSelectedSubIndex();
    let parentIndex = this.items.indexOf(this.selectedParent);
  
    if(index > 0) {
      let prev = this.selectedParent.subItems![index-1];
      this.onItemClick(prev, this.selectedParent);
    } else if(parentIndex > 0) {
      let prevParent = this.items[parentIndex - 1];
      if (prevParent.subItems?.length) {
        let lastSub = prevParent.subItems[prevParent.subItems.length - 1];
        this.onItemClick(lastSub, prevParent);
      }
    }
    setTimeout(() => this.scrollParentToSelected(), 0);
  }
  
  public goNext() {
    if(!this.selectedParent || !this.selectedItem) {
      return;
    }
    this.resetAllVars();
    let index = this.getSelectedSubIndex();
    let parentIndex = this.items.indexOf(this.selectedParent);
    if(index < this.selectedParent.subItems!.length - 1) {
      let next = this.selectedParent.subItems![index + 1];
      this.onItemClick(next, this.selectedParent);
    } else if(parentIndex < this.items.length - 1) {
      let nextParent = this.items[parentIndex + 1];
      if(nextParent.subItems?.length) {
        let firstSub = nextParent.subItems[0];
        this.onItemClick(firstSub, nextParent);
      }
    }
    setTimeout(() => this.scrollParentToSelected(), 0);
  }

  private updateProgress() {
    let all = 0;
    let done = 0;
    this.items.forEach(subitem => {
      subitem.subItems?.forEach(item => {
        all++;
        if(item.state === 'success'){
          done++;
        }
      });      
    });
    this.progress = Math.round((done/all)*100);
    this.eolDone = this.progress === 100;
    if(this.progress === 100) {
      this.eolCompleted = true;
      this.stopDataRetrieval();
    }
  }

  public scrollParentToSelected() {
    let activeEl = document.querySelector('mat-list-item.selected');
    if(activeEl) {
      activeEl.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    }
  }

  updateUrl(event: any){
    event.target.src = "../../assets/images/machine/renderings/default.png";
  }

  private resetSelectedItemExecText(item: SubItem) {
    item.exec = [];
  }

  private setImageUrl(imgName: string) {
    this.dataRetrieval.getTestImg(imgName).subscribe({
      next: (res) => {
        if(res.body) {
          this.selectedImgUrl = URL.createObjectURL(res.body);
        }
      }
    });
  }

  private resetImgUrl() {
    if (this.selectedImgUrl) {
      URL.revokeObjectURL(this.selectedImgUrl);
      this.selectedImgUrl = '';
    }
  }

  public openImage(){
    this.imgOpen = true;
  }

  public closeImage() {
    this.imgOpen = false;
  }

  /*public goToLogStep(stepper: MatStepper) {
    this.continueOn(stepper);
    if(!this.eolDone) {
      this.dialog.open(ComissionDialog, {
        width: '50%',
        data: 'check'
      }).afterClosed().subscribe((res) => {
        if(res) {
          this.continueOn(stepper);
        }
      });
    } else if(this.eolDone) {
      this.continueOn(stepper);
    }
  }*/

  public continueOn(stepper: MatStepper) {
    this.saveEOL().then(() => {
      this.eolCompleted = true;
      setTimeout(() => {
        stepper.selectedIndex = 2;
        this.fetchReport();
        //this.initLogPage();
      }, 250);
    });
  }


  // REPORT 

  private fetchReport() {
    this.reportLoading = true;
    this.reportSubscription = interval(1000).pipe(
      exhaustMap(() => this.dataRetrieval.getReport(this.machinenumber).pipe(
        catchError(err => {
          if(err.status === 404) {
            return EMPTY;
          }
          throw err;
        })
      )),
      filter(resp => resp.status === 200),
      take(1)
    ).subscribe({
      next: (res) => {
        if(res.body) {
          this.reportLink = URL.createObjectURL(res.body);
          this.reportLoading = false;
          this.reportSuccess = true;
        }
      },
      error: (err) => {
        console.error(err);
        this.reportLoading = false;
        this.reportError = true;
      }
    });
  }


}

// Dialog
@Component({
  selector: 'comission-dialog',
  templateUrl: 'comission-dialog.html',
  styleUrls: ['./comission-dialog.scss']
})
export class ComissionDialog {

  public done: boolean = false;
  public check: boolean = false;
  public error: boolean = false;
  public errorTest: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ComissionDialog>, private router: Router) {
    dialogRef.disableClose = true;
    if(data === 'done') {
      this.done = true;
    }
    if(data === 'check') {
      this.check = true;
    }
    if(data === 'error') {
      this.error = true;
    }
    if(data === 'errorTest') {
      this.errorTest = true;
    }
  }

  public backToMenu() {
    this.router.navigate(['/menu']);
    this.dialogRef.close();
  }

  public continue() {
    this.dialogRef.close(true);
  }

}
